// @flow
import { takeEvery, put, call } from 'redux-saga/effects';
import { fetchSimProductPriceFailure, fetchSimProductPriceSuccess } from './';
import { tripica } from '../../../api';
import HandleErrorService from '../../../lib/handleError';
import WizzeeLog from '../../../lib/wizzeeLog';

export function* getSimProductPriceSaga(): Generator<*, *, *> {
  try {
    const simProductPrice = yield call([tripica, 'getSimProductPrice']);
    yield put(fetchSimProductPriceSuccess(simProductPrice));
  } catch (e) {
    WizzeeLog.warn('[saga] fetchSimProductPrice', e);
    yield put(fetchSimProductPriceFailure(e));
    HandleErrorService.showToastError(e);
  }
}

export default function*(): Generator<*, *, *> {
  yield* [takeEvery('FETCH_SIM_PRODUCT_PRICE', getSimProductPriceSaga)];
}
